import React from "react";
import {Card, WingBlank, WhiteSpace} from 'antd-mobile';


import MobileWrapper from '../../layouts/MobileWrapper';






class MobileAnnouncementDetail extends React.Component {

    constructor(props) {
        super(props)

        this.state = {
            data: props.fatherProps.location.state
        }

        console.log(this.state.data)

    }



    render() {

        return <div>
            <WingBlank size="sm">
            <WhiteSpace size="sm" />
                <Card>
                  <Card.Header
                    title={this.state.data.title}
                    // extra={<span>{this.state.data.start_date_str}</span>}
                  />
                  <Card.Body>
                    <div>发布时间：{this.state.data.created_time_str}</div>
                    <WhiteSpace size="md" />
                    <div dangerouslySetInnerHTML={{__html:this.state.data.content}}></div>
                  </Card.Body>
                  <Card.Footer content=""/>
                </Card>
                        
            </WingBlank>
        </div>


    }
}

export default MobileWrapper(MobileAnnouncementDetail);


// WEBPACK FOOTER //
// ./src/routes/Mobile/MobileAnnouncementDetail.js